import React, { Component } from 'react';
import userService from '../../services/user.service'
import GoogleMap from './google-map/GoogleMap'
import Login from '../auth/login/Login'
import './Addresses.css'
import Timeline from '../timeline/Timeline'

declare var $;
declare var fbq;


class Addresses extends Component {


  constructor(props) {
    super(props)
    this.state  = {
      addresses: [],
      userData: [],
      openGoogleMap: false,
      getNewAddress: false,
      error: '',
      selectedAddress: null,
      openLogin: false,
      user: [],
      loading: false
    }
    this.setAddress = this.setAddress.bind(this)
    this.openGoogleMap = this.openGoogleMap.bind(this)
    this.openLogin = this.openLogin.bind(this)
    this.getNewAddress = this.getNewAddress.bind(this)
    this.getUserData = this.getUserData.bind(this)
    this.nextStep = this.nextStep.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.stepBack = this.stepBack.bind(this);
    this.openCart = this.openCart.bind(this)
  }


  async componentWillMount() {
    if(this.props.userData) {
         this.getUserData(this.props.userData)
    } else {
       let userData = JSON.parse(localStorage.getItem('user_data'))
       this.getUserData(userData)
    }

  }

  componentWillReceiveProps(nextProps) {

  }


  componentDidMount() {
    this.setState({
      openGoogleMap: false,
      loading: false
    })
    fbq('track', 'ViewContent', {
     content_name: 'addresses'
    });
  }

  componentWillReceiveProps(nextProps) {
    this.getUserData(nextProps.userData)
    if(nextProps.error) {
      this.setState({
        error: nextProps.error,
        loading: false
      })
    } 
  }

   getUserData(userData) {
    let addresses = userData.addresses;
    let selectedAddress = addresses.filter(address => address.active === true)[0]
    let openGoogleMap;
    if(addresses.length > 0) {
      openGoogleMap = false;
    } else {
      openGoogleMap = true;
    }
    this.setState({
      addresses,
      userData,
      selectedAddress,
      openGoogleMap
    })

  }

  setAddress(selectedAddress) {
   this.state.openGoogleMap = false;
   if(this.state.selectedAddress) {
        this.state.selectedAddress.active = false;
   }
   this.setState({
     openGoogleMap: false,
     loading:true
   })
   this.state.selectedAddress = selectedAddress
   selectedAddress.active = true;
   fbq('trackCustom', 'Address', {
      content_name: 'select'
    });
   this.nextStep()
  }

  openGoogleMap() {
    if(this.state.selectedAddress) {
      this.state.selectedAddress.active = false;
    }
    this.setState({
      selectedAddress: null,
      openGoogleMap: true,
      openLogin: false,
      loading: false,
      error: ''
    })
  }

  openLogin() {
    if(this.state.selectedAddress) {
      this.state.selectedAddress.active = false;
    }
    this.setState({
      selectedAddress: null,
      openGoogleMap: false,
      openLogin: true
    })
  }

  async getNewAddress(address) {
    if(Object.keys(address).length != 0) {
      address.application_user_id = this.state.userData.id
      let response = await userService.addAddress(address)
      let selectedAddress = this.state.selectedAddress
      if(selectedAddress) {
        selectedAddress.active = true
        this.setState({
          selectedAddress
        })
      }
      fbq('trackCustom', 'Address', {
         content_name: 'add'
       });
      this.state.addresses.unshift(response.address)
      this.state.openGoogleMap = false;
      this.setAddress(response.address)
   } else {
     this.state.error =  'Selecciona una dirección'
   }
  }

  nextStep() {
    if(!this.state.openGoogleMap) {
      if (!this.state.selectedAddress ) {
        this.setState({
          error: 'Selecciona una dirección'
        })
      } else {
         this.props.setSelectedAddress(this.state.selectedAddress)
      }
    } else {
      this.setState({
        getNewAddress: true
      })
    }
  }

  handleLogin(e) {
    if(JSON.parse(localStorage.getItem('user_data')).id === this.state.userData.id) {
      this.openGoogleMap()
    }
  }

  stepBack() {
    let step = this.props.step;
    step--
    this.props.continue(step)
  }

  openCart() {
    this.props.cart(true)
  }

  render() {
    var addresses = [];
    for (let address of this.state.addresses) {
      address.active = false;
      addresses.push(
        <li className={"collection-item avatar " + (address.active ? 'active pulse' : 'inactive')}  key={address.id} onClick={() => this.setAddress(address) }>
          <i className="material-icons circle">location_on</i>
          <span className="title truncate">{address.address}</span>
          { address.description &&  <p>{address.description}</p>} <br/>
          { !address.description &&  <p>Sin descripción</p>}
        </li>
      )
     }

    return (
      <div>
        <header>
        <nav>
         <div className="nav-wrapper no-color">
           <a  className="brand-logo center">¿A dónde te lo llevamos {this.state.userData.first_name}?</a>
           <a onClick={this.stepBack} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
         { /* <ul id="nav-mobile" className="right">
             <li><a onClick={this.openCart}><i className="material-icons cart">shopping_basket</i></a></li>
           </ul> */ }
         </div>
        </nav>

      <Timeline delivery="true"></Timeline>
    </header>
      <section id="addresses"  className="animated fadeIn">
      { (!this.state.openGoogleMap && !this.state.loading ) &&
       <div className="center action container">
              <a  onClick={this.openGoogleMap} className="waves-effect waves-light btn btn-orange"> <div>Agregar nueva dirección</div> </a>
        </div>
      }

      {this.state.loading && 
       <div className="row container"> 
          <div className="progress">
              <div className="indeterminate"></div>
          </div> 
        </div>
       }

      { this.state.error !== '' && 
      <div className="center">
        <p  className="error animated shake">{this.state.error}</p> 
      </div>
      }
      { !this.state.openGoogleMap &&   <div className="row">
            <div className="container">
                <p>Selecciona una dirección</p>
            </div>
                <div className="addresses">
                  <ul className="collection">
                    {addresses}
                  </ul>
                </div>
            </div> }

                <div id="map">
                { this.state.openGoogleMap &&
                  <GoogleMap needAddress={this.state.getNewAddress} setAddress={this.getNewAddress.bind(this)}></GoogleMap>
                }
                </div>

          { this.state.openGoogleMap  &&
            <div className="center action container">
              {this.state.loading && <div className="progress">
                  <div className="indeterminate"></div>
              </div> }
                { this.state.error !== '' && <p  className="error animated shake">{this.state.error}</p> }

                <a onClick={this.nextStep} className={"waves-effect waves-light btn btn-orange "  + (this.state.loading ? 'disabled' : ' ')}> <div>Agregar</div> </a>

            </div>
            }
      </section>
      </div>
    );
  }


}
export default Addresses;



// WEBPACK FOOTER //
// ./src/components/addresses/Addresses.js